<template>
  <el-dialog :title="auditInfo.title" :visible.sync="auditInfo.showDia" v-if="auditInfo.showDia"
    :close-on-click-modal="false">
    <el-form :model="ruleForm" ref="rForm" label-width="100px" class="ruleForm" :rules="rules">
      <el-form-item label="审核意见：" prop="myAuditStatus">
        <el-radio-group v-model="ruleForm.myAuditStatus">
          <el-radio v-for="(item, i) in auditScheduleAttr" :key="i" :label="item.paramKey">
            {{ item.paramValue }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="驳回原因：" v-if="ruleForm.myAuditStatus == 0">
        <el-input type="textarea" :row="3" placeholder="请输入驳回原因" maxlength="200" show-word-limit
          v-model="ruleForm.auditContent"></el-input>
      </el-form-item>


      <el-form-item label="短信通知：" prop="isSendSms">
        <el-radio v-model="ruleForm.isSendSms" label="1">是</el-radio>
        <el-radio v-model="ruleForm.isSendSms" label="0">否</el-radio>
      </el-form-item>

      <el-form-item label="发送对象：" v-if="ruleForm.isSendSms == 1">
        {{ rowData.userName }}
      </el-form-item>
      <el-form-item label="消息内容：" v-if="ruleForm.isSendSms == 1">
        <el-input type="textarea" :row="3" disabled v-model="auditContent"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeFrom()" btntype title="取消"></butn>
      <butn btntype="primary" @click.native="updateForm()" title="确定"></butn>
    </div>

  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { auditUpdate } from "@/api/user";
import { getDataMap } from "@/api/sysParam";
// import Upload from "@/components/upload/index";
import Bus from "./Bus.js";
import { submitModifyMobileAudit } from "@/api/user";

import {
  topicLectureLearnTemplate,
} from "@/assets/excel/index.js";

export default {
  name: 'auditor',
  components: { butn },
  props: ["auditInfo"],
  data() {
    return {
      size: "small",
      ruleForm: {
        myAuditStatus: '1',
        auditContent: '',
        isSendSms: '1'
      },
      showMan: false,
      auditScheduleAttr: [

        {
          "paramKey": "1",
          "paramValue": "同意"
        },
        {
          "paramKey": "0",
          "paramValue": "不同意"
        },
      ],
      memberList: [],
      rules: {
        myAuditStatus: [{ required: true, message: "请选择审核意见" }],

        isSendSms: [{ required: true, message: "请选择短信通知" }],
        auditContent: [

          { required: true, message: '请输入驳回原因', trigger: 'blur' },
        ],
      },

      EXCP: topicLectureLearnTemplate,
      rowData: {}
    };
  },
  methods: {
    // dealPhone(val) {
    //   return val.substring(0, 3) + '****' + val.substring(7)
    // },
    selectAuditor() {
      Bus.$emit("selectAuditor", this.deptId);
    },
    handleChange() { },
    auditScheduleChange(val) {
      this.showMan = val == 3;
    },
    closeFrom() {
      this.$emit("closeDia", 0, 0);
    },
    updateForm() {
      this.$refs["rForm"].validate((valid) => {
        if (valid) {
          if (this.ruleForm.myAuditStatus == 0 && !this.ruleForm.auditContent) {
            this.$message.warning('请输入驳回原因!!');
            return
          }

          const { query } = this.$route
          let row = JSON.parse(query.row)
          let params = {
            ...this.ruleForm,
            step: 1,
            userAuditUuid: row.userAuditUuid,
            smsContent: this.auditContent,
          };
          console.log('params', params)
          submitModifyMobileAudit(params).then((res) => {
            if (res.code === 0) {

              this.$message.success(res.msg);
              this.$emit("closeDia", 0, 1);
            }
          });
        }
      });
    },
  },
  computed: {
    auditContent() {
      let s = ''
      let v = this.ruleForm.myAuditStatus
      if (v == 0) {
        s = `您好，您提交的修改手机号申请审核不通过。原因：${this.ruleForm.auditContent ? this.ruleForm.auditContent : ''}`
      }
      if (v == 1) {
        const { query } = this.$route
        let row = JSON.parse(query.row)
        s = `您好，您提交的修改手机号申请已审核通过，您可以用新手机号${this.$dealPhone(row.newMobile)}登录浙里学习。`
      }
      return s
    },

  },
  watch: {
    'auditInfo.showDia'(v, oV) {
      if (v) {
        this.ruleForm = {
          myAuditStatus: '1',
          auditContent: '',
          isSendSms: '1'
        }
      }
    },
  },
  created() {
    let v = this.$route.query?.row || {}
    this.rowData = JSON.parse(v)
  },
};
</script>

<style lang="scss" scoped>
.button-dept {
  margin-left: 10px;
}
</style>
